import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import { BrowserRouter } from 'react-router-dom'
import AppProvider from './hooks'
import MainRoutes from './routes'

ReactDOM.render(
    <React.StrictMode>
        <AppProvider>
            <BrowserRouter>
                <MainRoutes />
            </BrowserRouter>
        </AppProvider>
    </React.StrictMode>,
    document.getElementById('root')
)
